var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCsm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "csm") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.86 18.62v13.3a6.65 6.65 0 0 0 0-13.3z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6 2.88a1.33 1.33 0 0 0-1.26-0.11l-21.03 9.2h-15.68a13.3 13.3 0 0 0 0 26.6h15.68l21.03 9.2a1.33 1.33 0 0 0 1.86-1.22v-42.56a1.33 1.33 0 0 0-0.6-1.11z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.87 54.01l-5.14-12.78h-11.31l6.76 16.68a5.22 5.22 0 0 0 9.69-3.9z",
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsm);
export default __webpack_public_path__ + "static/media/csm.ab15a41503c15c9c5e24a4c9285280be.svg";
export { ForwardRef as ReactComponent };